//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  data() {
    return {
      show: true
    }
  },
  computed: {
    ...mapState([ 'product', 'order' ])
  },
  methods: {
    hide() {
      this.show = false
    },
  }
}
